var exports = {
  "ee": "x0a7806d5--d5a938--mortgage-banner",
  "vW": "x0a7806d5--d5a938--inner",
  "DD": "x0a7806d5--d5a938--title",
  "h_": "x0a7806d5--d5a938--description",
  "wm": "x0a7806d5--d5a938--logo",
};

module.exports = exports;
